import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { API_ENDPOINTS } from "./Utils/endpoints";

export const GetDoctorList = (params: any) =>
  GET_ENC(API_ENDPOINTS.DOCTOR.LIST + params, null);

export const GetDoctorDetail = (params: any) =>
  GET_ENC(API_ENDPOINTS.DOCTOR.GET + params, null);

export const CreateDoctor = (data: any) =>
  POST_ENC(API_ENDPOINTS.DOCTOR.CREATE, data);

export const UpdateDoctor = (data: any) =>
  POST_ENC(API_ENDPOINTS.DOCTOR.UPDATE, data);

export const DeleteDoctor = (data: any) =>
  POST_ENC(API_ENDPOINTS.DOCTOR.DELETE, data);
